<template>
  <div class="container">
    <div class="bg-ff flex f-jcenter bg-fff pa-t-40 pa-b-40" v-if="!isWeixin">
      <div class="flex f-between width80">
        <div class="t-center stop c-red">
          <i class="iconfont icon-dingdandingdanmingxishouzhimingxi"></i>
          <div class="ma-t-10">第一步 提交订单</div>
        </div>
        <div class="t-center stop flex f-jcenter f-center">
          <i class="iconfont icon-xiayibu c-666"></i>
        </div>
        <div class="t-center stop">
          <i class="iconfont icon-zhangdan"></i>
          <div class="ma-t-10 c-666">第二步 确认支付</div>
        </div>
        <div class="t-center stop flex f-jcenter f-center">
          <i class="iconfont icon-xiayibu c-666"></i>
        </div>
        <div class="t-center stop">
          <i class="iconfont icon-dingdan-yiwancheng"></i>
          <div class="ma-t-10 c-666">第三步 支付成功</div>
        </div>
      </div>
    </div>

    <div class="pa-30 bg-fff ma-t-20">
      <div class="fon-18 font-bold">请填写收货地址：</div>
      <div class="flex ma-t-10">
        <div>请填写手机号：</div>
        <div>
          <el-input
            v-model="formData.Phone"
            placeholder="请输入手机号"
            size="mini"
          ></el-input>
        </div>
      </div>
    </div>

    <el-row type="flex" justify="space-between" class="bg-fff ma-t-20 f-wrap">
      <el-col :xs="24" :sm="12" class="pa-30">
        <div class="fon-18 font-bold">确认订单信息：</div>
        <div class="flex ma-t-20">
          <div class="width20">回报档</div>
          <div>
            <div>￥{{ amountData.Price }}({{ amountData.Name }})</div>
            <div class="c-yellow">
              *该产品为定制产品，众筹成功后不支持无理由退货退款
            </div>
          </div>
        </div>

        <div class="flex ma-t-20">
          <div class="width20">购买数量</div>
          <div>
            <el-input-number
              v-model="formData.Count"
              :min="1"
              size="small"
            ></el-input-number>
          </div>
        </div>
        <!-- 
        <div class="flex ma-t-20">
          <div class="width20">运费</div>
          <div>￥0</div>
        </div>

        <div class="flex ma-t-20">
          <div class="width20">额外打赏</div>
          <div>
            <el-input
              v-model="formData.OtherAmount"
              placeholder="请输入打赏金额"
              size="mini"
              type="number"
            ></el-input>
          </div>
        </div> -->

        <div class="flex ma-t-20">
          <div class="width20">留言</div>
          <div>
            <el-input
              v-model="formData.Remark"
              placeholder="请输入特殊要求"
              size="mini"
            ></el-input>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" class="b-l-1-ee flex f-center f-jcenter">
        <div class="t-center">
          <div class="fon-22 font-bold">￥{{ totalPrice }}</div>
          <div>实际支付金额</div>
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" class="f-wrap bg-fff ma-t-20 pa-30">
      <el-col :xs="24" :sm="3" class="fon-18 font-bold">免责协议：</el-col>
      <el-col :xs="24" :sm="20" class="c-666">
        <div class="">
          1.点击“确认支付”，即表明您已阅读并同意 《众筹协议》
          及《隐私权政策》，并自愿承担众筹相应风险。
        </div>
        <div class="ma-t-20">
          2.参与众筹不是直接的商品交易，因此存在一定风险。请您根据自己的判断选择、支持众筹项目。
        </div>
      </el-col>
    </el-row>

    <div class="pa-30 bg-fff ma-t-20 ma-b-30 t-center">
      <div class="btn-support" @click="btnAddOrder()">提 交</div>
      <!-- <span class="c-666 ma-l-20">请在提交后10分钟内支付，过期将失效</span> -->
    </div>
  </div>
</template>

<script>
import {
  postCrowdFundingAdd,
  getCrowdFundingDetail,
  getMember,
  orderPay
} from '../../api.js'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      amountData: {},
      projectData: {},
      amountId: '',
      projectId: '',

      formData: {
        Count: 1,
        OtherAmount: 0,
        AmountId: 0,
        Id: 0,
        Phone: '',
        Remark: ''
      },
      projectName: '', //项目名称
      isWeixin: false
    }
  },
  activated() {
    if (
      this.$route.query.amountId != this.amountId ||
      this.$route.query.projectId != this.projectId
    ) {
      this.amountId = this.$route.query.amountId
      this.projectId = this.$route.query.projectId
      this.formData.Id = this.$route.query.projectId
      this.formData.AmountId = this.$route.query.amountId
      //判断是否在微信浏览器里，如果在微信支付时使用微信支付，否则使用扫码支付
      var ua = navigator.userAgent.toLowerCase()
      this.isWeixin = ua.indexOf('micromessenger') != -1
      this.loadData()

      getMember().then((res) => {
        this.formData.Phone = res.data.Data.Phone
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0)

    next()
  },
  methods: {
    //获取众筹信息
    loadData() {
      getCrowdFundingDetail({ id: this.projectId }).then((res) => {
        this.projectData = res.data.Data
        this.amountData = this.projectData.AmountList.find((item) => {
          if (item.Id == this.amountId) {
            return item
          }
        })
      })
    },
    //微信内支付
    wxPay(weixin) {
      var _this=this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        appId: weixin.AppId, // 必填，公众号的唯一标识
        timestamp: weixin.TimeStamp, // 必填，生成签名的时间戳
        nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
        signature: weixin.PaySign, // 必填，签名
        jsApiList: ['chooseWXPay'] // 必填，需要使用的 JS 接口列表
      })
      wx.ready(function () {
        //发起微信支付
        wx.chooseWXPay({
          timestamp: weixin.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
          nonceStr: weixin.NonceStr, // 支付签名随机串，不长于 32 位
          package: weixin.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: weixin.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: weixin.PaySign, // 支付签名
          success: function () {
            _this.$alert('支付成功', '提示', {
              confirmButtonText: '确认',
              showClose: false,
              type: 'success'
            })
              .then(() => {
                // 支付成功后的回调函数
                _this.$router.push({
                  path: '/crowdfunding/detail',
                  query: {
                    id: _this.projectId
                  }
                })
              })
              .catch(() => {})
          }
        })
      })
    },
    //下单
    btnAddOrder() {
      let token = localStorage.getItem('AccessToken')
      if (!token) {
        this.$alert('您还未登录请先登录', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/Login')
          })
          .catch(() => {})
        return
      }

      //数据验证
      if (!this.formData.Phone) {
        this.$message({
          message: '请填写手机号',
          type: 'warning'
        })
        return
      }
      if (!/^1\d{10}$/.test(this.formData.Phone)) {
        this.$message({
          message: '手机号格式错误',
          type: 'warning'
        })
        return
      }

      console.log(this.formData)
      postCrowdFundingAdd(this.formData).then((res) => {
        console.log(res.data.Data)
        if (this.isWeixin) {
          let openid = localStorage.getItem('openid')
          orderPay({
            Key: res.data.Data.Key,
            Type: this.isWeixin ? 'weixinm' : 'weixin',
            OpenId: openid
          }).then((res) => {
            this.wxPay(res.data.Data.Data)
          })
        } else {
          this.$router.push({
            path: '/crowdfunding/pay-2',
            query: {
              Key: res.data.Data.Key,
              projectId: this.projectId,
              amountId: this.amountId
            }
          })
        }
      })
    }
  },
  computed: {
    totalPrice() {
      return (
        this.formData.Count * this.amountData.Price +
        Number(this.formData.OtherAmount)
      ).toFixed(2)
    }
  }
}
</script>

<style  lang="scss" scoped>
.b-l-1-ee {
  border-left: 1px solid #eee;
}
.stop {
  .iconfont {
    font-size: 50px;
  }
}
.c-yellow {
  color: #f8ab6b;
}
.btn-support {
  padding: 10px 70px;
  background: #fb004d;
  display: inline-block;
  color: #fff;
  cursor: pointer;
}
</style>